// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { SimpleSelectOptionType } from '@epicuro-next/features/landing-panel';
import { MediaType } from '@epicuro-next/models/engagement';
import { IDynamicItemValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Product } from 'graphql-api/gql-api-interfaces';
import {
  RecommendedItemProducts,
  RecommendedItemsResponseType,
} from 'models-recommendation';

import { SingleProductDataType } from '../../../types/single-product-data-type';

export type BestPerformingArticlesDataType = SingleProductDataType;

export type BestPerformingArticlesPayloadPropertiesType = {
  brandOrg?: string;
  datePeriodDays?: number;
  orderType: number;
  filterMissingImages: boolean;
  category?: string;
  loadPrices?: boolean;
};

export function createApiRequestPayloadPropertiesProvider(providers: {
  datePeriodDays: IDynamicItemValue;
  orderType: IDynamicItemValue;
  filterMissingImages: IDynamicItemValue;
  category?: IDynamicItemValue;
  brandOrganisationId?: IDynamicItemValue;
}): IDynamicItemValue {
  return {
    values: [
      providers.brandOrganisationId,
      providers.datePeriodDays,
      providers.orderType,
      providers.filterMissingImages,
      providers.category,
    ],
    transform: function ([
      brandOrganisationId,
      datePeriodDays,
      orderType,
      filterMissingImages,
      category,
    ]: [string, number, number, boolean, SimpleSelectOptionType]) {
      const payloadProperties: BestPerformingArticlesPayloadPropertiesType = {
        brandOrg: brandOrganisationId ?? undefined,
        datePeriodDays,
        orderType,
        filterMissingImages,
        category: category?.value ?? undefined,
      };

      return { ...payloadProperties, loadPrices: true };
    }.toString(),
  };
}

export function getApiResponseTransformMethod() {
  return function (
    recommendedItemsResponse: RecommendedItemsResponseType<RecommendedItemProducts>,
  ): BestPerformingArticlesDataType[] {
    const productsData: BestPerformingArticlesDataType[] = [];
    for (const itemInDataSet of recommendedItemsResponse.result.dataSet) {
      const item = itemInDataSet.item;

      const productData: BestPerformingArticlesDataType = {
        media: {
          mediaType: 'IMAGE' as MediaType,
          url: item.media?.[0]?.src?.[0]?.url ?? '',
        },
        configStrip: {
          overlayPath: [
            'cs',
            item.brandId,
            item.masterProduct?.productId ?? 'PARENT ID NA',
            item.productId,
          ],
        },
        product: {
          ...item,
          articleTitle: item.masterProduct?.title ?? item.title,
        } as unknown as Product,
        correlationId: recommendedItemsResponse.operationId,
        hash: recommendedItemsResponse.hash,
        providerId: recommendedItemsResponse.result.metadata.providerid,
        servingConfig: recommendedItemsResponse.result.metadata.provider,
        attributionToken: null,
      };

      productsData.push(productData);
    }
    return productsData;
  };
}
